import React from 'react';
function RadioButtons({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <circle cx="12" cy="17" r="4" />
      <circle cx="12" cy="7" r="4" />
      <circle cx="12" cy="7" r="1" />
    </svg>
  );
}

export default RadioButtons;
